// extracted by mini-css-extract-plugin
module.exports = {"block":"src-components-common-block-___block__block___14GgN","width100":"src-components-common-block-___block__width100___2c6D9"};